module.exports = __webpack_public_path__ + "img/PGR_A05_front_cross_horizontal_en.e2c7c908.png";